export const SET_CURRENT_OPERATOR = 'setcurrentoperator';
export const LOADING = 'set_loading';
export const SET_OPERATORS = 'set_operators';
export const SHOW_DIALOG = 'show_dialog';
export const SET_CHANGE_RESOURCE = 'setchangeresource';
export const SET_VALIDATION_CODE = 'setvalidationcode';
